import { HashLink } from 'react-router-hash-link';
import { detailsTeams } from '../../data/Data';
import Card from '../../UI/Card';
import './Team.css';

export default function Team() {
  return (
    <div>
      <h2 className="main">Meet the Team</h2>
      <section>
        <div className="team-container">
          <div className="team-grid">
            {detailsTeams.map(({ id, name, title, description, img, link }) => (
              <Card key={id} className="card stacked">
                <img src={img} alt={name} className="card__img" />
                <div className="card__content">
                  <HashLink smooth to={link}>
                    <h3 className="card__title">{title}</h3>
                  </HashLink>
                  <p className="card__description">{description}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
